import { Box, Stack, Typography } from '@mui/material';

type Props = {
  title: string;
  description: string;
  note?: string;
};

export default function IndustrialCostSectionPlaceholder({
  title,
  description,
  note,
}: Props) {
  return (
    <Box
      sx={{
        borderRadius: 4,
        border: '1px dashed rgba(148,163,184,0.28)',
        bgcolor: 'rgba(15,23,42,0.42)',
        px: 3,
        py: 3,
      }}
    >
      <Stack spacing={1}>
        <Typography variant="h6" sx={{ color: '#f8fafc', fontWeight: 800 }}>
          {title}
        </Typography>

        <Typography variant="body2" sx={{ color: '#cbd5e1', lineHeight: 1.65 }}>
          {description}
        </Typography>

        {note ? (
          <Typography variant="caption" sx={{ color: '#94a3b8', lineHeight: 1.5 }}>
            {note}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
}